import React from 'react';
import cn from 'classnames';
import Icon from '../Icon';
import './Button.css';

/**
 * Reusable button. Purely presentational — variant/size are config-driven and
 * it supports loading + icon states. No business logic lives here.
 */
const Button = ({
  children,
  variant = 'primary', // primary | secondary | ghost | danger | subtle
  size = 'md', // sm | md | lg
  type = 'button',
  loading = false,
  disabled = false,
  block = false,
  iconLeft,
  iconRight,
  className,
  ...rest
}) => {
  const isDisabled = disabled || loading;
  return (
    <button
      type={type}
      disabled={isDisabled}
      className={cn(
        'kvo-btn',
        `kvo-btn--${variant}`,
        `kvo-btn--${size}`,
        { 'kvo-btn--block': block, 'kvo-btn--loading': loading },
        className
      )}
      {...rest}
    >
      {loading && <span className="kvo-btn__spinner" aria-hidden="true" />}
      {!loading && iconLeft && <Icon name={iconLeft} size={size === 'sm' ? 14 : 16} />}
      {children && <span className="kvo-btn__label">{children}</span>}
      {!loading && iconRight && <Icon name={iconRight} size={size === 'sm' ? 14 : 16} />}
    </button>
  );
};

export default Button;
